import { HeaderBackButton, HeaderBackButtonProps } from '@react-navigation/elements'
import { NavigationProp, ParamListBase, useNavigation } from '@react-navigation/native'
import React from 'react'

import { ArrowLeft } from '../images/Common/ArrowLeft'

// This component is used to override the default back button behavior in the header
// It allows us to redirect to a different screen even if the browser is refreshed
export const CustomHeaderBackButton: React.FC<
  HeaderBackButtonProps & { navigation: NavigationProp<ParamListBase>; callRedirect?: VoidFunction }
> = ({ callRedirect, navigation, ...rest }) => {
  const globalNav = useNavigation()

  return (
    <HeaderBackButton
      {...rest}
      style={{ marginLeft: 0, paddingLeft: 0 }}
      backImage={ArrowLeft}
      onPress={() => {
        if (navigation.canGoBack()) return navigation.goBack()
        if (callRedirect) return callRedirect()
        return globalNav.navigate('Main', { screen: 'HomeTab', params: { screen: 'HowCanWeHelp' } })
      }}
    />
  )
}

export default CustomHeaderBackButton
